// Module
var code = `<div class="row">
    <table class="table">
        <tr>
            <th>Product key</th>
            <th>Price</th>
            <th>Days since install</th>
            <th>Player</th>
            <th>Env</th>
        </tr>
        <tr ng-repeat="p in data">
            <td>
                <div title="Product key">{{p.product_key}}</div>
                <div
                    title="Purchase datetime"
                >{{p.purchase_datetime}}</div>
                <a ui-sref="amt.ww2.offers.offer({offer_id: p.offer_id})" ui-sref-opts="{inherit: false}" target="_blank" title="Offer">
                    {{p.offer_title}}
                </a>
            </td>
            <td>
                <span title="Purchase price">{{p.price}}</span>
            </td>
            <td>{{p.day_since_install}}</td>
            <td>
                <div title="Player ID">{{p.player_id}}</div>
                <div
                    title="App install campaign"
                    ng-if="p.campaign"
                    style="margin-top: 5px; background-color: #d9edf7"
                >{{p.campaign}}</div>
            </td>
            <td>
                <div title="Env">{{p.env}}</div>
                <div ng-if="p.build_name != p.env" title="Build name">{{p.build_name}}</div>
                <div title="Gameplay">{{p.gameplay | lowercase}}</div>
            </td>
        </tr>
    </table>
</div>
`;
// Exports
module.exports = code;